export default ({ data, id, slugs }) => ({
	id,
	slug: slugs[0],
    job_title:data.job_title,
    full_name: data.full_name,
    review: data.review.map(({ text }) => text).join("<br/>"),
    link: data.link.url
});
